import { z } from 'zod';
export const ContactCreationModeSchema = z.enum(['all', 'selective', 'none']);
export const SignatureSlotSchema = z.enum(['primary', 'secondary']);
export const MailboxBlockEntryTypeSchema = z.enum(['email', 'domain']);
export const UpdateWorkspaceEmailCalendarSettingsSchema = z.object({
    contactCreationMode: ContactCreationModeSchema,
});
export const UpdateUserEmailCalendarSettingsSchema = z.object({
    autoCreateClientsFromSyncedContacts: z.boolean(),
});
export const CreateMailboxBlockEntrySchema = z.object({
    type: MailboxBlockEntryTypeSchema,
    value: z.string().trim().min(1).max(255),
});
export const UpdateUserEmailSignatureSettingsSchema = z.object({
    primaryHtml: z.string().max(100_000),
    secondaryHtml: z.string().max(100_000),
    activeSignatureSlot: SignatureSlotSchema.nullable(),
});
